import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineArrowLeft } from "react-icons/ai";
import UserCard from "../../components/user/UserCard";
import ButtomButton from "../../components/DocButtomButton";
import {
  fetchEvent,
  joinEvent,
  fetchEventAttendees,
  leaveEvent,
} from "../../actions/event.action";
import { Loading } from "../../utils/helpers/constants";
import RoundLoader from "../../components/loader/RoundLoader";
import { dateFormatterUI3 } from "../../utils/helpers/dataHelper";

export default function EventDetails() {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    event: {
      event,
      attendees,
      loading,
      eventLoading,
      creator,
      eventAttendeesLoading,
      joinEventLoading,
      userAttendee,
    },
  } = useSelector(({ eventReducer }) => ({
    event: eventReducer,
  }));

  const { profile } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  useEffect(() => {
    dispatch(fetchEvent(id));
    dispatch(fetchEventAttendees(id));
  }, []);

  const handleAttending = () => {
    dispatch(joinEvent(id, event.name));
  };

  const handleUnAttend = () => {
    dispatch(leaveEvent(id, event.name));
  };

  function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  const compassLogo =
    "https://res.cloudinary.com/landmark-university-alumni-association/image/upload/v1657472072/Admin/favlcon_pfrtsr.png";

  const buttonLoadState = joinEventLoading === Loading.FETCHING;
  const loadState =
    eventLoading === Loading.FETCHING ||
    eventAttendeesLoading === Loading.FETCHING ||
    profile.userProfileLoading === Loading.FETCHING;

  return (
    <div>
      {loadState ? (
        <RoundLoader />
      ) : (
        <>
          <div>
            <div className="mt-5 mx-5">
              <div className="flex justify-between mb-6">
                <div className="flex cursor-pointer">
                  <AiOutlineArrowLeft
                    size={25}
                    onClick={() => history.goBack()}
                  />
                </div>
                <div className="single_line font-bold text-xl font-serif mx-2">
                  {event.name}
                </div>
                <div></div>
              </div>
              {isObjectEmpty(event) && loading === Loading.ERROR ? (
                <></>
              ) : (
                <div className="rounded w-full md:flex md:justify-between">
                  <div className="md:mr-10 md:w-1/2">
                    <img
                      className="object-fill w-full h-72"
                      src={event.imageUrl === "" ? compassLogo : event.imageUrl}
                      alt={event.name}
                    />
                  </div>
                  <div className="py-4 md:p-4 md:border-l md:w-1/2">
                    <div className="text-sm text-gray-400 mb-1 mt-2">
                      Description:
                    </div>
                    <div className={`text-xs mb-1`}>{event.description}</div>
                    <div>
                      <div className="text-sm text-gray-400 mb-1">
                        Event Date:
                      </div>
                      <div className="text-xs text-yellow-400 mb-2">
                        {dateFormatterUI3(event.eventDate)}
                      </div>
                      <div className="text-sm text-gray-400 mb-1 mt-0">
                        Address:
                      </div>
                      <div className="mb-2">
                        {event?.address?.locationAddress}
                      </div>
                      <div className="text-sm text-gray-400 mb-1 mt-0">
                        Organizer:
                      </div>
                      <UserCard user={creator} />
                      <div className="text-sm text-gray-400 mb-2 mt-5">
                        Attendees:
                      </div>
                      <div className="mb-5 overflow-auto">
                        {attendees.map((attendee, index) => {
                          return (
                            <div className="mb-2" key={index}>
                              <UserCard user={attendee} />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    {userAttendee ? (
                      <ButtomButton
                        name={"Un-Attend"}
                        func={handleUnAttend}
                        loading={buttonLoadState}
                      />
                    ) : (
                      <ButtomButton
                        name={"I’m Attending"}
                        func={handleAttending}
                        loading={buttonLoadState}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
